import React from 'react';

const CStatCard = ({ icon, title, value }) => {
  return (
    <div className="glass-card p-4">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Events {title}</p>
          <h4 className="text-2xl font-bold text-navy-700 dark:text-white">{value}</h4>
        </div>
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-orange-50 dark:bg-navy-700 text-orange-500">
          {icon}
        </div>
      </div>
    </div>
  );
};
export default CStatCard;